import { GenericRateSheetLine } from '@/components/account/account-scaling/rate-sheet-definitions/RateSheetDefinitions'
import { cloneDeep } from 'lodash'

export const RateSheetInteractionMode = {
  RateSheetDefinition: {
    View: 0,
    Create: 1,
    Edit: 2
  },
  RateSheet: {
    View: 3,
    Create: 4,
    Edit: 5
  }
}
class RateSheetRequest {
  constructor (
    activityDetailId,
    productId,
    rateSheetDefinitionId,
    effectiveDate,
    rateSheetLines
  ) {
    this.activityDetailId = activityDetailId
    this.productId = productId
    this.rateSheetDefinitionId = rateSheetDefinitionId
    this.effectiveDate = effectiveDate
    this.rateSheetLines = rateSheetLines
  }
}

export class RateSheetBuilder {
  constructor (
    activityDetail = null,
    product = null,
    rateSheetDefinition = null,
    effectiveDate = null,
    rateSheetLines = null
  ) {
    this.activityDetail = activityDetail
    this.product = product
    this.rateSheetDefinition = rateSheetDefinition
    this.effectiveDate = effectiveDate
    this.rateSheetLines = rateSheetLines
  }

  get request () {
    return new RateSheetRequest(
      this.activityDetail?.id,
      this.product?.productId,
      this.rateSheetDefinition?.id,
      this.effectiveDate,
      this.rateSheetLines.map((l) => l.request)
    )
  }
}

export class RateSheetLineBuilder extends GenericRateSheetLine {
  constructor (rateSheetLineId = null, rate = null, speciesGroup = null, lengthGroup = null, diameterGroup = null, grade = null, endUseSort = null,
    isLocked = false, isDeleted = false) {
    super(rate, speciesGroup, lengthGroup, diameterGroup, grade, endUseSort)
    this.rateSheetLineId = rateSheetLineId
    this.isLocked = isLocked
    this.isDeleted = isDeleted
  }
}

export function rateSheetLineFromServerToBuilder (line) {
  const lineClone = cloneDeep(line)
  return new RateSheetLineBuilder(
    lineClone.rateSheetLineId,
    lineClone.rate,
    lineClone.speciesGroupId ? {
      speciesGroupId: lineClone.speciesGroupId,
      label: lineClone.speciesGroupLabel
    } : null,
    lineClone.lengthGroupId ? {
      lengthGroupId: lineClone.lengthGroupId,
      label: lineClone.lengthGroupLabel
    } : null,
    lineClone.diameterGroupId ? {
      diameterGroupId: lineClone.diameterGroupId,
      label: lineClone.diameterGroupLabel
    } : null,
    lineClone.gradeId ? {
      gradeId: lineClone.gradeId,
      name: lineClone.gradeName
    } : null,
    lineClone.endUseSortId ? {
      endUseSortId: lineClone.endUseSortId,
      name: lineClone.endUseSortName
    } : null,
    lineClone.isLocked ?? false,
    false
  )
}
